var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.192 24V13.0374H17.8456L18.3757 8.79395H14.1322V6.0832C14.1322 4.84543 14.485 4.02024 16.253 4.02024H18.4933V0.189336C17.3976 0.0647436 16.2954 0.00549844 15.1926 0.0119327C14.4442 -0.0390673 13.6938 0.073822 12.9936 0.342712C12.2933 0.611602 11.6602 1.03004 11.1383 1.56881C10.6164 2.10758 10.2184 2.75371 9.97191 3.46215C9.72545 4.17059 9.63652 4.92427 9.71132 5.67061V8.79395H6V13.0374H9.71333V24H14.192Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8f1e4cba975e7606feab19b5d8351063.svg";
export { ForwardRef as ReactComponent };